import React, { useEffect, useState } from "react"
import {
    Container,
    Row,
    Col,
    Carousel,
    CarouselItem,
    CarouselControl,
    CarouselIndicators,
} from "reactstrap"
import "./app.css"
import TileContainer from "../containers/TitleContainer"
import invisiBreak from "../assets/pattern-3.svg"
import courtyard from "../assets/courtyard.jpeg"
import courtyard2 from "../assets/courtyard2.jpeg"
import courtyardflowers from "../assets/courtyardflowers.jpeg"
import robin from "../assets/robin.jpeg"

const courtyardGalleryContext = require.context("../assets/galleryImages/cafe/courtyard", false, /\.(png|jpe?g|webp)$/i)
const courtyardGalleryImages = courtyardGalleryContext
    .keys()
    .sort()
    .map((imagePath) => courtyardGalleryContext(imagePath))

const bannerItems = [courtyard, courtyard2, courtyardflowers, robin, ...courtyardGalleryImages].map((src, index) => ({
    src,
    altText: `Courtyard image ${index + 1}`,
    caption: `Courtyard image ${index + 1}`,
}))

const Courtyard = () => {
    const [activeIndex, setActiveIndex] = useState(0)
    const [animating, setAnimating] = useState(false)

    const next = () => {
        if (animating) return
        const nextIndex = activeIndex === bannerItems.length - 1 ? 0 : activeIndex + 1
        setActiveIndex(nextIndex)
    }

    const previous = () => {
        if (animating) return
        const nextIndex = activeIndex === 0 ? bannerItems.length - 1 : activeIndex - 1
        setActiveIndex(nextIndex)
    }

    const goToIndex = (newIndex) => {
        if (animating) return
        setActiveIndex(newIndex)
    }

    useEffect(() => {
        const rotationTimer = setTimeout(() => {
            setActiveIndex((currentIndex) => (currentIndex === bannerItems.length - 1 ? 0 : currentIndex + 1))
        }, 4500)

        return () => clearTimeout(rotationTimer)
    }, [activeIndex])

    const slides = bannerItems.map((item) => (
        <CarouselItem
            onExiting={() => setAnimating(true)}
            onExited={() => setAnimating(false)}
            key={item.src}
        >
            <div
                style={{
                    textAlign: "center",
                    backgroundColor: "#d7d2c2",
                    borderRadius: 6,
                    overflow: "hidden",
                    maxWidth: 520,
                    margin: "0 auto",
                }}
            >
                <img
                    src={item.src}
                    alt={item.altText}
                    style={{ width: "100%", aspectRatio: "3 / 4", objectFit: "cover", objectPosition: "center" }}
                />
            </div>
        </CarouselItem>
    ))

    return (
        <Container fluid>
            <TileContainer title={"Our Courtyard"} />
            <Row className="row-m-20">
                <Col className="col-m-b-20 remove-padding">
                    <div className="textContainer">
                        <p>We are lucky to have a large outdoor courtyard. The two tier, large paved areas are bordered by informal planting designed to provide a haven for wildlife, especially garden birds. We don’t use weedkillers or pesticides and are careful to only prune outside nesting season. Plentiful seating and undercover areas are provided.</p>
                        <Row style={{ marginTop: 10 }}>
                            <Col className="col-m-b-20" md={{ size: 8, offset: 2 }}>
                                <Carousel className="courtyard-carousel" activeIndex={activeIndex} next={next} previous={previous}>
                                    <CarouselIndicators
                                        items={bannerItems}
                                        activeIndex={activeIndex}
                                        onClickHandler={goToIndex}
                                    />
                                    {slides}
                                    <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
                                    <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
                                </Carousel>
                            </Col>
                        </Row>
                    </div>
                </Col>
            </Row>
            <Row className="row-m-20">
                <Col className="remove-padding">
                    <div>
                        <img src={invisiBreak} alt="" className="center" style={{ width: "100%", height: "50%", borderRadius: 5, opacity: 0.5 }} />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default Courtyard